module.exports = __webpack_public_path__ + "static/media/IL.2d7ed5d5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/IL.svg
// module id = 2172
// module chunks = 7